import InlineSVG from "react-inlinesvg";
import { cn } from "src/lib/cn";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip";

type SeriesTagVariant = "default" | "collapsed" | "chiclet";

function SeriesTag({
  projectTitle,
  collapsed = false,
  variant,
  className,
  ...props
}: {
  projectTitle?: string;
  collapsed?: boolean;
  variant?: SeriesTagVariant;
  className?: string;
}) {
  const resolvedVariant: SeriesTagVariant = variant ?? (collapsed ? "collapsed" : "default");
  const label = projectTitle || "Series";
  const markerColorClass = "text-app-grey-1 [&_path]:fill-app-grey-1";

  if (resolvedVariant === "chiclet") {
    return (
      <div
        className={cn(
          "inline-flex items-center gap-0.5 pl-1 pr-1.5 py-0.5 rounded-[10px] border-[1.5px] border-app-menu-color-transparent-30 h-5 max-w-[12rem]",
          className,
        )}
        {...props}
      >
        <InlineSVG
          src="/assets/series.svg"
          width={14}
          height={14}
          className="shrink-0 text-app-grey-1 [&_path]:fill-app-grey-1"
        />
        <SudoTooltip
          text={label}
          onlyShowOnOverflow
          triggerAs="span"
          triggerClassName="min-w-0 cursor-default text-xs font-medium text-app-grey-1 truncate leading-none"
        >
          {label}
        </SudoTooltip>
      </div>
    );
  }

  return (
    <div className={cn("series-tag flex min-w-0 items-center gap-1", resolvedVariant !== "collapsed" && "min-w-[80px] shrink", className)} {...props}>
      {resolvedVariant === "collapsed" && (
        <SudoTooltip
          text={label}
          triggerClassName="series-tag flex items-center gap-1 flex-shrink [&>svg]:flex-shrink-0"
        >
          <InlineSVG
            src="/assets/series.svg"
            width={18}
            height={18}
            className={`${markerColorClass} cursor-default`}
          />
        </SudoTooltip>
      )}
      {resolvedVariant === "default" && (
        <>
          <InlineSVG
            src="/assets/series.svg"
            width={18}
            height={18}
            className={`${markerColorClass} shrink-0 cursor-default`}
          />
          <SudoTooltip
            text={label}
            onlyShowOnOverflow
            triggerAs="p"
            triggerClassName={`min-w-0 cursor-default truncate text-sm font-medium ${markerColorClass}`}
          >
            {label}
          </SudoTooltip>
        </>
      )}
    </div>
  );
}

export default SeriesTag;
